import React from "react";
import CButton from "@app/components/Common/CButton";
import { COLORS } from "@app/constants/STYLES";
import { TransactionNavBarSection, TransactionNavBarWrapper } from "./styles";
import { useTranslation } from "react-i18next";

interface IProps {
  buy?: boolean;
  setBuy?: any;
}

const TransactionNavBar = ({ buy, setBuy }: IProps) => {
  const { t } = useTranslation();
  const transactionBtn = () => {
    setBuy(!buy);
  };
  return (
    <TransactionNavBarSection>
      <TransactionNavBarWrapper>
        <CButton
          title={t("buy")}
          onClick={transactionBtn}
          style={{
            padding: 7,
            fontWeight: "bold",
            color: COLORS.grayWhite,
            width: "50%",
            backgroundColor: buy ? COLORS.lightGreen : "transparent",
          }}
        />
        <CButton
          title={t("sell")}
          onClick={transactionBtn}
          style={{
            padding: 7,
            fontWeight: "bold",
            color: COLORS.grayWhite,
            width: "50%",
            backgroundColor: !buy ? COLORS.lightRed : "transparent",
          }}
        />
      </TransactionNavBarWrapper>
    </TransactionNavBarSection>
  );
};

export default React.memo(TransactionNavBar);
